<div class="dialog-content-wrapper" cslPerfectScrollbar>
  <mat-toolbar class="mat-accent m-0">
    <mat-toolbar-row class="flex flex-auto justify-between items-center">
      <span class="title dialog-title" i18n *ngIf="!title">Скидки на материалы</span>
      <span class="title dialog-title" *ngIf="title">{{ title }}</span>
      <button mat-button class="mat-icon-button" (click)="dialogRef.close(undefined)" aria-label="Close dialog">
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>

  <mat-divider> </mat-divider>

  <div mat-dialog-content class="p-0 pb-0 m-0 ps" cslPerfectScrollbar>
    <csl-group-matrial-discount-tree
      (discountChange)="discountsChanged($event)"
      [groupMaterials]="groups"
      [groupMaterialsDiscounts]="discounts"
      [readonly]="readonly"></csl-group-matrial-discount-tree>
  </div>
  <mat-divider></mat-divider>
  <div mat-dialog-actions class="m-0 p-4 flex justify-end items-center">
    <button mat-raised-button class="mat-accent mr-4" [disabled]="!discounts" (click)="dialogRef.close(discounts)" i18n
      >ОК</button
    >
    <button mat-button (click)="dialogRef.close(undefined)" i18n>ОТМЕНА</button>
  </div>
</div>
